export enum PaperSizeEnums {
  //Tamaños Papel Impresión
  letter = 1,
  halfLetter = 2
}
